import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

import logoImg from '~/assets/icons/logo.webp';
import { DESKTOP_MIN_WIDTH } from '~/constants/common';

import circlesImage from './assets/circles.svg';
import peopleImage from './assets/people.png';
import qrCodeImage from './assets/qr-code.svg';
import { Slider } from './components/slider';
import {
  StyledContainer,
  StyledContentContainer,
  StyledFormContainer,
  StyledImg,
  StyledImgContainer,
  StyledLogo,
} from './styled';

type AuthLayoutProps = PropsWithChildren<{
  isSlider: boolean;
}>;

export default function AuthLayout({ children, isSlider }: AuthLayoutProps) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));
  const navigate = useNavigate();

  return (
    <StyledContainer>
      <StyledContentContainer>
        <StyledLogo src={logoImg} onClick={() => navigate('/')} />
        <StyledFormContainer>{children}</StyledFormContainer>
      </StyledContentContainer>
      {isDesktop && (
        <StyledImgContainer>
          <StyledImg src={circlesImage} $mt={-65} />

          {isSlider ? (
            <Slider />
          ) : (
            <>
              <StyledImg src={qrCodeImage} />
              <StyledImg src={peopleImage} height={447} />
            </>
          )}
        </StyledImgContainer>
      )}
    </StyledContainer>
  );
}
